/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestItem } from './RequestItem';
import {
    RequestItemFromJSON,
    RequestItemFromJSONTyped,
    RequestItemToJSON,
    RequestItemToJSONTyped,
} from './RequestItem';

/**
 * 
 * @export
 * @interface RequestCreateInboundPlanRequest
 */
export interface RequestCreateInboundPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    addressLine?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    addressLine1: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateInboundPlanRequest
     */
    baseId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateInboundPlanRequest
     */
    createdUserId: number;
    /**
     * 
     * @type {Array<RequestItem>}
     * @memberof RequestCreateInboundPlanRequest
     */
    items: Array<RequestItem>;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateInboundPlanRequest
     */
    stateOrProvinceCode: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateInboundPlanRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestCreateInboundPlanRequest interface.
 */
export function instanceOfRequestCreateInboundPlanRequest(value: object): value is RequestCreateInboundPlanRequest {
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('createdUserId' in value) || value['createdUserId'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('stateOrProvinceCode' in value) || value['stateOrProvinceCode'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestCreateInboundPlanRequestFromJSON(json: any): RequestCreateInboundPlanRequest {
    return RequestCreateInboundPlanRequestFromJSONTyped(json, false);
}

export function RequestCreateInboundPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateInboundPlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine': json['address_line'] == null ? undefined : json['address_line'],
        'addressLine1': json['address_line1'],
        'baseId': json['base_id'],
        'city': json['city'],
        'countryCode': json['country_code'],
        'createdUserId': json['created_user_id'],
        'items': ((json['items'] as Array<any>).map(RequestItemFromJSON)),
        'name': json['name'],
        'phoneNumber': json['phone_number'],
        'postalCode': json['postal_code'],
        'stateOrProvinceCode': json['state_or_province_code'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestCreateInboundPlanRequestToJSON(json: any): RequestCreateInboundPlanRequest {
    return RequestCreateInboundPlanRequestToJSONTyped(json, false);
}

export function RequestCreateInboundPlanRequestToJSONTyped(value?: RequestCreateInboundPlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line': value['addressLine'],
        'address_line1': value['addressLine1'],
        'base_id': value['baseId'],
        'city': value['city'],
        'country_code': value['countryCode'],
        'created_user_id': value['createdUserId'],
        'items': ((value['items'] as Array<any>).map(RequestItemToJSON)),
        'name': value['name'],
        'phone_number': value['phoneNumber'],
        'postal_code': value['postalCode'],
        'state_or_province_code': value['stateOrProvinceCode'],
        'tenant_id': value['tenantId'],
    };
}

